import { MyDemandsFields } from 'utils/__interfaces/MyDemands/myDemands'

export const maxNumberFiles = 10
export const maxTotalFilesSize = 25 * 1048576
export const BILLING_ADDRESS = 'Principale'
export const CATEGORY_ADMINISTRATIVE = 'ADMINISTRATIF'

export const FIELDS_NAMES = {
  PRESTATION: 'prestationName',
  NUMBER_OF_CONTAINER: 'numberContainer',
  DOSSIER: 'dossier',
  EXPECTED_SERVICE_DATE: 'date',
  DESCRIPTION: 'description',
  ATTACHMENT: 'attachment',
}

export const FORM1: MyDemandsFields[] = [
  {
    type: 'search',
    name: FIELDS_NAMES.PRESTATION,
    mandatory: true,
    additionalProps: {
      className: 'col-12',
    },
  },
  {
    type: 'search',
    name: FIELDS_NAMES.DOSSIER,
    mandatory: true,
    additionalProps: {
      className: 'col-12',
    },
  },
  {
    type: 'date',
    name: FIELDS_NAMES.EXPECTED_SERVICE_DATE,
    mandatory: true,
    additionalProps: {
      isOutsideRangeRule: 'j-1',
      className: 'col-lg-6 col-md-12',
    },
  },
  {
    type: 'textarea',
    name: FIELDS_NAMES.DESCRIPTION,
    mandatory: false,
    additionalProps: {
      maxCharacterLength: 32000,
      className: 'col-12',
    },
  },
  {
    type: 'file',
    name: FIELDS_NAMES.ATTACHMENT,
    mandatory: false,
    additionalProps: {
      className: 'col-12',
    },
  },
]

export const FORM2: MyDemandsFields[] = [
  {
    type: 'search',
    name: FIELDS_NAMES.PRESTATION,
    mandatory: true,
    additionalProps: {
      className: 'col-12',
    },
  },
  {
    type: 'search',
    name: FIELDS_NAMES.DOSSIER,
    mandatory: true,
    additionalProps: {
      className: 'col-12',
    },
  },
  {
    type: 'textarea',
    name: FIELDS_NAMES.DESCRIPTION,
    mandatory: true,
    additionalProps: {
      maxCharacterLength: 32000,
      className: 'col-12',
    },
  },
  {
    type: 'file',
    name: FIELDS_NAMES.ATTACHMENT,
    mandatory: false,
    additionalProps: {
      className: 'col-12',
    },
  },
]

export const FORM3: MyDemandsFields[] = [
  {
    type: 'search',
    name: FIELDS_NAMES.PRESTATION,
    mandatory: true,
    additionalProps: {
      className: 'col-12',
    },
  },
  {
    type: 'search',
    name: FIELDS_NAMES.DOSSIER,
    mandatory: false,
    additionalProps: {
      className: 'col-12',
    },
  },
  {
    type: 'textarea',
    name: FIELDS_NAMES.DESCRIPTION,
    mandatory: true,
    additionalProps: {
      maxCharacterLength: 32000,
      className: 'col-12',
    },
  },
  {
    type: 'file',
    name: FIELDS_NAMES.ATTACHMENT,
    mandatory: false,
    additionalProps: {
      className: 'col-12',
    },
  },
]

export const FORM4: MyDemandsFields[] = [
  {
    type: 'search',
    name: FIELDS_NAMES.PRESTATION,
    mandatory: true,
    additionalProps: {
      className: 'col-12',
    },
  },
  {
    type: 'search',
    name: FIELDS_NAMES.DOSSIER,
    mandatory: true,
    additionalProps: {
      className: 'col-12',
    },
  },
  {
    type: 'date',
    name: FIELDS_NAMES.EXPECTED_SERVICE_DATE,
    mandatory: false,
    additionalProps: {
      isOutsideRangeRule: 'j-1',
      className: 'col-lg-6 col-md-12',
    },
  },
  {
    type: 'textarea',
    name: FIELDS_NAMES.DESCRIPTION,
    mandatory: true,
    additionalProps: {
      maxCharacterLength: 32000,
      className: 'col-12',
    },
  },
  {
    type: 'file',
    name: FIELDS_NAMES.ATTACHMENT,
    mandatory: false,
    additionalProps: {
      className: 'col-12',
    },
  },
]

export const FORM5: MyDemandsFields[] = [
  {
    type: 'search',
    name: FIELDS_NAMES.PRESTATION,
    mandatory: true,
    additionalProps: {
      className: 'col-12',
    },
  },
  {
    type: 'number',
    name: FIELDS_NAMES.NUMBER_OF_CONTAINER,
    mandatory: false,
    additionalProps: {
      className: 'col-12',
    },
  },
  {
    type: 'search',
    name: FIELDS_NAMES.DOSSIER,
    mandatory: true,
    additionalProps: {
      className: 'col-12',
    },
  },
  {
    type: 'date',
    name: FIELDS_NAMES.EXPECTED_SERVICE_DATE,
    mandatory: true,
    additionalProps: {
      isOutsideRangeRule: 'j-1',
      className: 'col-lg-6 col-md-12',
    },
  },
  {
    type: 'textarea',
    name: FIELDS_NAMES.DESCRIPTION,
    mandatory: false,
    additionalProps: {
      maxCharacterLength: 32000,
      className: 'col-12',
    },
  },
  {
    type: 'file',
    name: FIELDS_NAMES.ATTACHMENT,
    mandatory: false,
    additionalProps: {
      className: 'col-12',
    },
  },
]
